var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main",class:{'main-hide-text': _vm.shrink}},[_c('div',{staticClass:"single-page-con",style:({width: '100%'})},[_c('div',{staticClass:"single-page",staticStyle:{"margin-left":"0px"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }